import { inventoryApi } from '../api/inventoryApi'

export const getCategories = async () => {
  try {
    const {
      data: { categories },
    } = await inventoryApi.getCategories()
    return categories
  } catch (error) {
    console.error(`Error fetching inventory categories: `, error)
    throw error
  }
}
